export const SGDP_ORGANIZATION_ID: string = '5068093D-AA1F-41F8-AC42-1FC85A92B766';
export const SGDP_BRANDING: string = 'sgdp';
export const ADHA_STATE: string = 'ADHA';
export const PURCHASE_BASE_PATH: string = '/purchase';
export const WIDGET_STYLES_BUNDLE_ID: string = 'wf-widget-styles';
